<template>
    <div class="bg-grey-100 py-4">
        <AppContainer>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8 relative">
                <div>
                    <AppButton theme="white" :href="route('steves-reviews.index')">
                        Back to Steve's Reviews
                    </AppButton>

                    <h1 class="text-5xl text-dark mt-16 tracking-wide font-bold">{{ post.title }}</h1>

                    <p class="mt-4 text-dark">{{ post.posted_date }}
                        <div v-if="postAuthor">
                            <span v-if="post.created_by !== null || post.created_by.length">by </span>
                            <span class="font-bold">{{ post.created_by.name }}</span>
                        </div>
                    </p>
                </div>

                <div class="order-first md:order-last">
                    <AppVideo
                        :type="post.video_type"
                        :clip="post.video_id"></AppVideo>
                </div>

                <div class="absolute -bottom-8 lg:-right-4 xl:-right-16 hidden lg:block">
                    <img src="/images/steves-reviews.png" :alt="post.title" />
                </div>

            </div>
        </AppContainer>
    </div>

    <AppContainer>
        <div class="grid grid-cols-none lg:grid-cols-2 gap-4 mt-4">
            <div>
                <p>{{ post.excerpt }}</p>

                <div class="my-8 w-24 bg-primary h-1"></div>

                <div class="mb-4 post-content" v-html="post.content"></div>

                <template v-if="post.cta_text && post.cta_link">
                    <AppButton v-if="!ctaIsExternal" :href="post.cta_link">
                        {{ post.cta_text }}
                    </AppButton>
                    <a v-else :href="post.cta_link" target="_blank">
                        <AppButton>
                            {{ post.cta_text }}
                        </AppButton>
                    </a>
                </template>
            </div>
            <div>
                <h2 class="text-2xl text-dark font-bold mb-4">Featured reviews</h2>

                <Transition mode="out-in" name="fade">
                    <div v-if="featuredProducts.length > 0" class="grid grid-cols-2 sm:grid-cols-3 gap-4">
                        <TyreCard v-for="product of featuredProducts" :product="product"></TyreCard>
                    </div>
                    <div v-else class="grid grid-cols-3 gap-4">
                        <TyreCardLoader :items="2"></TyreCardLoader>
                    </div>
                </Transition>

                <div v-if="moreArticles.length">
                    <h2 class="text-2xl text-dark font-bold my-4 mt-16">
                        Read more
                    </h2>
                    <div class="flex flex-col gap-4">
                        <div v-for="extraArticle of moreArticles" class="grid grid-cols-3 items-center gap-4">
                            <img v-if="extraArticle.image || extraArticle.videos.length === 0"
                                 :src="extraArticle.image ?? '/images/misc/default_news.jpg'"
                                 class="object-cover aspect-video rounded-lg"
                                 height="107">

                            <AppVideo v-else thumbnail-only
                                      :type="extraArticle.videos[0].type"
                                      :clip="extraArticle.videos[0].video_id"></AppVideo>

                            <div class="col-span-2">
                                <p class="text-lg font-bold pr-4">{{ extraArticle.title }}</p>

                                <AppButton class="mt-4" :href="route('news.show', extraArticle)">
                                    Read now
                                </AppButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="my-4">
                    <component is="script" async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8286486938913131"
                               crossorigin="anonymous"></component>
                    <!-- News Ads -->
                    <component is="ins" class="adsbygoogle"
                               style="display:block"
                               data-ad-client="ca-pub-8286486938913131"
                               data-ad-slot="1372330416"
                               data-ad-format="auto"
                               data-full-width-responsive="true"></component>
                    <component is="script">
                        (adsbygoogle = window.adsbygoogle || []).push({});
                    </component>
                </div>

                <h2 class="text-2xl text-dark font-bold my-4 mt-16">
                    Follow us
                </h2>

                <SocialLinks></SocialLinks>
            </div>
        </div>
    </AppContainer>
</template>

<script>
import AppContainer from "@/Layouts/AppContainer";
import AppButton from "@/Components/AppButton";
import AppVideo from "@/Components/AppVideo";
import SubscribeButton from "@/Components/Videos/SubscribeButton";
import SocialLinks from "@/Components/Social/SocialLinks";
import TyreCardLoader from "@/Components/Loaders/TyreCardLoader";
import TyreCard from "@/Components/Products/Tyres/TyreCard";
export default {
    name: "ViewReviewPost",
    components:
    {
        TyreCard,
        TyreCardLoader,
        SocialLinks,
        SubscribeButton,
        AppVideo,
        AppButton,
        AppContainer,
    },
    props: {
        post: Object,
        featuredProducts: Object,
        moreArticles: Object
    },
    data() {
        return {
            loadProducts: false,
            postAuthor: false,
            ctaIsExternal: false,
            products: []
        }
    },
    mounted()
    {
        if(!this.post.created_by)
        {
            this.postAuthor = false;
        }
        else
        {
            this.postAuthor = true;
        }

        if (!this.post.cta_link || !this.post.cta_link.length) this.ctaIsExternal = false;

        if(this.post.cta_link)
        {
            const match = this.post.cta_link.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);

            if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) this.ctaIsExternal = true;

            return typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":(" + {
                "http:": 80,
                "https:": 443
            }[location.protocol] + ")?$"), "") !== location.host;
        }
    },
}
</script>

<style>
    .post-content p {
        margin-bottom: 2rem !important;
    }
    .post-content img {
        margin-bottom: 2rem !important;
    }
</style>
